<template>
    <div>
        <el-dialog title="任务流转" :visible.sync="showForm" width="600px" :close-on-click-modal="false" center>
            <el-form label-width="120px" :model="formData">
                <el-form-item label="跟进人">
                    <el-select v-model="formData.handleId" clearable placeholder="请选择" >
                        <el-option v-for="(item,index) in personList" :key="index" :label="item.userName" :value="item.userId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注" prop="comment">
                    <el-input type="textarea" rows="6" v-model="formData.comment" placeholder="请输入跟进内容"
                        clearable></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showForm = false">取消</el-button>
                <el-button type="primary" @click="savelog">确定</el-button>
            </span>
        </el-dialog>


    </div>
</template>

<script>
import moment from "moment";
import workercrmapi from "@/script/api/workercrmapi";
import taskApi from "@/script/api/taskApi";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/service";
import globalData from "@/components/common/globaldata/global.data.vue";

import { validateIdNo } from "@/script/validator";

export default {
    components: {},

    filters: {

    },
    data() {
        return {
            showForm: false,
            tempRow: {},
            personList: [],
            formData: {
                taskId: '',
                handleId: '',
                handleName: '',
                comment: '',
            }
        }
    },
    methods: {
        deliverOper(taskRow) {
            this.showForm = true;
            this.tempRow = taskRow;
            this.formData = {
                taskId: taskRow.id,
                handleId: '',
                handleName: '',
                comment: '',
            }
            this.loadHandlePerson();
        },
        loadHandlePerson() {
            let req = {
                campaignId: this.tempRow.campaignId,
                cityId: this.tempRow.cityId
                // storeId: 
            };
            taskApi.$axiosSelectByTypeCityStore(req).then(res => {
                this.personList = res.data.data;
            })
        },
        savelog() {
            if (this.formData.handleId == '') {
                this.$message.error('请选择流转的人');
                return;
            }

            let name='';
            this.personList.forEach(e=>{
                if(e.userId==this.formData.handleId){
                    name=e.userName;
                }
            })
            this.formData.handleName=name;

            taskApi.$axioUpdateAppointPerson(this.formData).then(res => { 
                if (res.data.errno == 0) {
                    this.$message.success("操作成功");
                    this.showForm = false;
                    this.$parent.querySearch();
                } else {
                    this.$message.error(res.data.data);
                }
            })
        }
    }
};
</script>

<style scoped></style>
  